import { callApi } from './apiCall';


const responseMessage = (data, fallback) => {
    if (typeof data?.detail === 'string' && data.detail) return data.detail;
    if (typeof data?.message === 'string' && data.message) return data.message;
    return fallback;
};

const invalidContract = () => ({
    valid: false,
    success: false,
    severity: 'error',
    outcome: 'invalid_contract',
    message: 'The server returned an invalid duplicate-classification response. The lead was not updated locally.',
});

const isNonNegativeInteger = (value) => Number.isSafeInteger(value) && value >= 0;

export const getDuplicateClassificationFeedback = (data, expectedLeadId) => {
    if (!data || expectedLeadId == null || data.lead_id == null
        || String(data.lead_id) !== String(expectedLeadId)
        || typeof data.is_duplicate !== 'boolean'
        || data.is_spam !== false
        || typeof data.mapping_changed !== 'boolean'
        || !isNonNegativeInteger(data.mapped_duplicate_count)) {
        return invalidContract();
    }

    if (data.action === 'marked_duplicate'
        && data.is_duplicate === true
        && isNonNegativeInteger(data.matched_duplicate_count)
        && data.matched_duplicate_count > 0
        && data.matched_duplicate_count <= 9
        && data.matched_duplicate_count === data.mapped_duplicate_count
        && data.matched_duplicate_count_lower_bound == null) {
        return {
            valid: true,
            success: true,
            severity: 'success',
            outcome: 'marked_duplicate',
            message: responseMessage(data, 'Lead is marked as duplicate.'),
        };
    }

    if (data.action === 'no_exact_matches'
        && data.is_duplicate === false
        && data.matched_duplicate_count === 0
        && data.matched_duplicate_count_lower_bound == null
        && data.mapped_duplicate_count === 0) {
        return {
            valid: true,
            success: false,
            severity: 'warning',
            outcome: 'no_exact_matches',
            message: responseMessage(data, 'No exact duplicate matches were found.'),
        };
    }

    if (data.action === 'too_many_exact_matches'
        && data.matched_duplicate_count == null
        && isNonNegativeInteger(data.matched_duplicate_count_lower_bound)
        && data.matched_duplicate_count_lower_bound >= 10
        && data.mapping_changed === false
        && data.is_duplicate === (data.mapped_duplicate_count > 0)) {
        return {
            valid: true,
            success: false,
            severity: 'warning',
            outcome: 'too_many_exact_matches',
            message: responseMessage(
                data,
                'At least 10 exact matches were found. No duplicate links were changed.'
            ),
        };
    }

    return invalidContract();
};

export const requestMarkAsDuplicate = async (practiceId, leadId) => {
    const response = await callApi(
        `/api/v1/practices/${practiceId}/leads/${leadId}/mark_as_duplicate/`,
        'post'
    );

    if (response.status !== 200) {
        return {
            response,
            feedback: {
                valid: false,
                success: false,
                severity: 'error',
                outcome: 'request_failed',
                message: responseMessage(response?.data, 'Failed to mark lead as duplicate.'),
            },
        };
    }

    return {
        response,
        feedback: getDuplicateClassificationFeedback(response.data, leadId),
    };
};
